/**
 * Detects RLS errors caused by acting on suspended/archived patients
 * and returns a user-friendly Portuguese message.
 */
export function isPatientInactiveRlsError(error: unknown): boolean {
  if (!error) return false;
  const msg = (error as any)?.message?.toLowerCase?.() ?? '';
  const code = (error as any)?.code ?? '';
  return (
    code === '42501' ||
    msg.includes('row-level security') ||
    msg.includes('row level security') ||
    msg.includes('violates row-level security')
  );
}

export const PATIENT_INACTIVE_TOAST_MESSAGE =
  'Esta ação não é permitida para pacientes suspensos ou arquivados. Reative a assinatura ou desarquive o paciente para continuar.';
